/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImageCarouselComponent } from './image-carousel.component';
import { BulbImageModule } from '../image/bulb-image.module';
import { ImageCarouselCaptionComponent } from './image-carousel-caption/image-carousel-caption.component';

/**
 * Module for the Image carousel.
 */
@NgModule({
  declarations: [
    ImageCarouselComponent,
    ImageCarouselCaptionComponent,
  ],
  imports: [
    BulbImageModule,
    CommonModule,
  ],
  exports: [
    ImageCarouselComponent,
  ],
})
export class ImageCarouselModule { }
